import React, { FC, ReactNode } from 'react'

import { timelineClassNames } from './Timeline.constants'
import * as S from './Timeline.styles'

export interface TimelineProps {
  className?: string
  timeline: {
    timeStamp?: string
    timeStampCustom?: ReactNode
    content: ReactNode
    customPoint?: ReactNode
  }[]
  eventContentGap?: number
}

export const Timeline: FC<TimelineProps> = ({ className, timeline, eventContentGap = 16 }) => {
  return (
    <S.Root className={className} eventContentGap={eventContentGap}>
      {timeline.map(({ content, timeStamp, timeStampCustom, customPoint }, index) => (
        <S.ItemContainer key={`timeline-${index}`} className={timelineClassNames.timeItemContainer}>
          <S.HourDisplay className={timelineClassNames.timeStamp}>
            {timeStampCustom ?? timeStamp}
          </S.HourDisplay>

          <S.PointWrapper className={`${timelineClassNames.pointWrapper} point-${index}`}>
            {customPoint ?? <S.Point />}{' '}
            <S.Line
              className={`${timelineClassNames.lineComponent} line-${index}`}
              $hasCustomPoint={!!customPoint}
              eventContentGap={eventContentGap}
            />
          </S.PointWrapper>

          <S.ItemActivitiesContainer
            className={`${timelineClassNames.eventContainer} event-${index}`}
          >
            {content}
          </S.ItemActivitiesContainer>
        </S.ItemContainer>
      ))}
    </S.Root>
  )
}
